import React from 'react';
import PropTypes from 'prop-types';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import { FormattedMessageWrappedInSpan } from '../../misc';
import CustomDialog from './CustomDialog';
import EmbeddedVideo from '../../misc/EmbeddedVideo';

const VideoOfferPreviewDialog = ({ open, onRequestClose, videoUrl }) => {
  return (
    <CustomDialog hasFixedWidth={false} open={open} onRequestClose={onRequestClose}>
      <div className="notification-container notification-video">
        <DialogContent>
          <div className="notification-body ">
            <h1>
              <FormattedMessageWrappedInSpan
                id="offerTile.dialog.video.title"
                defaultMessage="Video preview"
              />
            </h1>
            <EmbeddedVideo videoUrl={videoUrl} />
          </div>
        </DialogContent>
        <DialogActions>
          <div className="notification-action">
            <button className="accept" onClick={onRequestClose}>
              <FormattedMessageWrappedInSpan
                id="offerTile.dialog.acceptButton"
                defaultMessage="Ok"
              />
            </button>
          </div>
        </DialogActions>
      </div>
    </CustomDialog>
  );
};

VideoOfferPreviewDialog.propTypes = {
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,
  videoUrl: PropTypes.string,
};

export default VideoOfferPreviewDialog;
